<template>
  <div id="index" class="contenido-oficina">
    <div class="w-100" style="height: var(--safe-area-inset-top)" v-if="asWideScreenMenu"></div>
    <div class="text-center c-pointer border bd-k10blue py-2 m-2 border-radius-10"
         @click="$router.push({name: 'koinonia10-vista-difusion', params: {username: 'Koinonia10'}})">
      <div class="pos-absolute pos-top-right px-1 bg-k10blue fg-white text-bold text-small border-radius-5 mr-1 mt-1">
        <span>Ir a Perfil Oficial K10</span>
      </div>
      <img src="@/assets/images/logos/koinonia10.webp" alt="" style="max-width: 90%">
    </div>
    <div class="row text-center fg-white mt-3 mx-2" style="row-gap: 8px">
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'koinonia10-cronologia-general'})">
          Red Social
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'herramientas-compra', query: {herramienta: 'saldo-koinonia10'}})">
          Obtener Saldo Koinonía10
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'koinonia10-saldo'})">
          Saldo Koinonía10
        </div>
      </div>
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'herramientas-compra', query: {herramienta: 'membresia-premium'}})">
          Membresía Premium K10
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'koinonia10-influencer'})">
          Influencer
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'spots-lista-0'})">
          Anunciantes
        </div>
      </div>
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'koinonia10-beneficios-saldo'})">
          Beneficios
        </div>
      </div>
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'miembros-f'})">
          <span>Beneficios de patrocinadores</span><br>
          <span style="font-size: 1rem">F4 y F3</span>
        </div>
      </div>
    </div>

    <div class="mx-4 mt-5" v-if="asWideScreenMenu" id="switch-menu">
      <img class="border border-radius-20 bd-orange border-size-2 p-2 c-pointer w-50"
           src="@/assets/images/logos/virtual-shopping-club.webp" alt="" @click="$emit('switch-menu')">
    </div>
    <div class="mt-10 mx-2 mb-2">
      <div class="text-small border border-radius-10 c-pointer text-center bd-lightBlue fg-darkBlue p-1"
           @click="safeRoutePush({name: 'help', params: {slug: 'terminos-y-condiciones-koinonia10'}})">
        <i class="fa-brands fa-readme mr-1"></i><span>Términos y Condiciones</span>
      </div>
    </div>
  </div>
</template>

<script>
import terminosCondiciones from "@/components/fondos/terminos-condiciones.vue"

export default {
  name: "index",
  props: {
    asWideScreenMenu: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    if (!this.asWideScreenMenu) {
      this.$store.commit('SET_NAVBAR_FG_COLOR', {'fg-white': true})
    }
  },
  mounted() {
    if (!this.asWideScreenMenu) {
      this.$store.commit('SET_SHOW_MENU', {show_menu: false, path: null})
      this.$store.commit('SET_TITLE_MENU', '')
      this.$store.commit('SET_NAVBAR_FG_COLOR', {'fg-red': true})
    }
  },
  methods: {
    showTerminos() {
      this.$store.commit('PUSH_TO_FULL_MODAL_POSITIONS', window.scrollY)
      this.$FModal.show(
        {
          component: terminosCondiciones,
          overlayStyles: {
            backgroundColor: 'rgba(12, 52, 161, 0.27)'
          },
          clickToClose: true,
        },
        {
          documentoSlug: 'terminos-y-condiciones-koinonia10'
        }
      )
    },
    safeRoutePush(route) {
      let differentRoute = this.$route.name !== route.name
      if (!differentRoute) {
        for (const property of ['params','query']) {
          const keysDest = route[property] ? Object.keys(route[property]) : []
          const keysSrc = Object.keys(this.$route[property])
          differentRoute = keysDest.length !== keysSrc.length
          if (!differentRoute && keysSrc.length > 0) {
            const uniqueKeys = [...new Set(keysSrc.concat(keysDest))]
            for (const key of uniqueKeys) {
              differentRoute = this.$route[property][key] !== route[property][key]
              if (differentRoute) {
                break
              }
            }
          }
          if (differentRoute) {
            break
          }
        }
      }
      if (differentRoute) {
        this.$router.push(route).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.options-gradient {
  background: #237ca6;
  background: linear-gradient(135deg,rgba(35, 124, 166, 1) 0%, rgba(0, 174, 255, 1) 100%);
}
@media (min-width: 1236px) {
  #switch-menu {
    display: none;
  }
}
</style>